/// <reference path="../../../typings/tsd.d.ts" /> 

module warsApp.services {
    export class LegendConfigurationService extends services.DataService < Wars.Domain.Model.Gis.LegendConfiguration> {

        constructor(injectedBreeze: typeof breeze, $q: angular.IQService, private $http: angular.IHttpService) {
            super(injectedBreeze, $q);
        }

        public createLegendConfiguration(): Wars.Domain.Model.Gis.LegendConfiguration{
            return this.createNewEntity<Wars.Domain.Model.Gis.LegendConfiguration>("LegendConfiguration");
        }

        public createLegendLayer(): Wars.Domain.Model.Gis.LegendLayer{
            return this.createNewEntity<Wars.Domain.Model.Gis.LegendLayer>("LegendLayer");
        }
    }
}

warsApp.registerService('LegendConfigurationService', ['breeze', '$q', '$http']);